import { useSelector } from "react-redux";

const KopThermalBill = ({ data }) => {
  const settings = useSelector((state) => state.settings.settings) || {};
  if (settings?.thermalPaperSize === "80") {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: "280px",
          padding: 8,
          marginBottom: 50,
        }}
      >
        <h5
          style={{
            textAlign: "center",
            margin: 9,
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          #{data.shopName}#
        </h5>
        <h6
          style={{
            textAlign: "center",
            margin: 9,
            fontWeight: "semibold",
            textTransform: "uppercase",
          }}
        >
          {data.orderType}
        </h6>
        {data?.tableNo && (
          <h6
            style={{
              textAlign: "center",
              margin: 8,
            }}
          >
            TABLE: {data?.tableNo}
          </h6>
        )}

        <p
          style={{
            flexBasis: "100%",
            margin: 0,
          }}
          id="kotNo"
        >
          Token No:{data?.kotNo}
        </p>
        <div
          style={{
            display: "flex",
            flexWrapper: "wrap",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              flexBasis: "50%",
              textAlign: "left",
            }}
          >
            {data.date}
          </p>
          <p
            style={{
              flexBasis: "50%",
              textAlign: "right",
            }}
          >
            {data.time}
          </p>
        </div>
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "8px 0",
          }}
        >
          <span>ITEM NAME</span>
          <span>QTY</span>
        </div>
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />

        {data?.products?.map((product, index) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "8px 0",
            }}
          >
            <span>{product.productName}</span>
            <span>{product.count}</span>
          </div>
        ))}
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: "180px",
          paddingLeft: 4,
          paddingRight: 4,
          marginBottom: 50,
          fontSize: "10px",
        }}
      >
        <h6
          style={{
            textAlign: "center",
            margin: 9,
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          #{data.shopName}#
        </h6>
        <h6
          id="kotOrderType"
          style={{
            textAlign: "center",
            margin: 9,
            fontWeight: "semibold",
            textTransform: "uppercase",
          }}
        >
          {data.orderType}
        </h6>
        {data?.tableNo && (
          <h6
            style={{
              textAlign: "center",
              margin: 8,
            }}
          >
            TABLE: {data?.tableNo}
          </h6>
        )}

        <p
          style={{
            flexBasis: "100%",
            margin: 0,
            fontSize: "10px",
          }}
          id="kotNo"
        >
          Token No:{data?.kotNo}
        </p>
        <div
          style={{
            display: "flex",
            flexWrapper: "wrap",
            justifyContent: "space-between",
            fontSize: "10px",
          }}
        >
          <p
            style={{
              flexBasis: "50%",
              textAlign: "left",
              margin: 0,
              fontSize: "10px",
            }}
          >
            {data.date}
          </p>
          <p
            style={{
              flexBasis: "50%",
              textAlign: "right",
              margin: 0,
              fontSize: "10px",
            }}
          >
            {data.time}
          </p>
        </div>
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "8px 0",
            fontSize: "10px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            ITEM NAME
          </span>
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            QTY
          </span>
        </div>
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />

        {data?.products?.map((product, index) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "8px 0",
              fontSize: "10px",
            }}
          >
            <span>{product.productName}</span>
            <span>{product.count}</span>
          </div>
        ))}
        <div
          style={{
            borderTop: "1px #000 dashed",
          }}
        />
      </div>
    );
  }
};

export default KopThermalBill;
